import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { getApiUrl, BASE_URL } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import placeholder from "../assets/sampleimage.png"; // fallback image

const Homeslider = () => {
  const [banners, setBanners] = useState([]);

  
  const fetchBanners = async () => {
    try {
      const res = await fetch(getApiUrl("homebanner-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const result = await res.json();
      if (result.success) {
        setBanners(result.data || []);
      }
    } catch (err) {
      toast.error("Failed to load banners");
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  return (
    <div className="homeslider-container ">
      <Swiper
        slidesPerView={1}
        loop
        navigation  
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        modules={[Pagination, Autoplay, Navigation]}
      >
        {banners.length > 0 ? (
          banners.map((banner, index) => (
            <SwiperSlide key={index}>
              <img
                src={banner ? `${BASE_URL}${banner}` : placeholder} 
                alt={`Banner ${index + 1}`}
                className="img-fluid rounded mb-2 w-100"
                style={{ objectFit: "cover" }}
              />
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide>
            <img src={placeholder} alt="Placeholder" className="img-fluid rounded mb-2 w-100" />
          </SwiperSlide>
        )}
      </Swiper>

      <ToastContainer />
    </div>
  );
};

export default Homeslider;
